import type * as React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="grid flex-1 place-items-center bg-background px-6 pb-16 pt-10">
      <div className="max-w-md text-center">
        {icon ? (
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-lg bg-muted">
            {icon}
          </div>
        ) : null}
        <h2 className="mt-4 text-lg font-semibold text-foreground">{title}</h2>
        {description ? <p className="mt-2 text-sm text-muted-foreground">{description}</p> : null}
        {action ? <div className="mt-6">{action}</div> : null}
      </div>
    </div>
  );
}
